import React from 'react';

const CloverIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 39 39">
    <g>
      <clipPath id="SVGID_2_">
        <use id="svg_2" />
      </clipPath>
      <g id="svg_12">
        <path
          id="svg_4"
          fill="#06E594"
          clipRule="evenodd"
          fillRule="evenodd"
          d="m28.7,19.1c5.3,0 9.6,-4.3 9.6,-9.6c0,-5.2 -4.3,-9.5 -9.6,-9.5c-5.3,0 -9.5,4.3 -9.6,9.5c0,-5.2 -4.3,-9.5 -9.6,-9.5c-5.2,0 -9.5,4.3 -9.5,9.6c0,5.3 4.3,9.5 9.5,9.6c-5.3,0 -9.5,4.3 -9.5,9.6c0,5.3 4.3,9.6 9.6,9.6c5.3,0 9.6,-4.3 9.6,-9.6c0,-5.3 -4.3,-9.5 -9.5,-9.6c5.2,0 9.5,-4.3 9.5,-9.5c0,5.2 4.2,9.4 9.5,9.4z"
          className="st1"
        />
        <path
          stroke="null"
          id="svg_5"
          fill="#06E594"
          d="m28.7,38.3c5.3,0 9.6,-4.3 9.6,-9.6s-4.3,-9.6 -9.6,-9.6s-9.6,4.3 -9.6,9.6s4.3,9.6 9.6,9.6z"
          className="st2"
        />
      </g>
    </g>
  </svg>
);

export default CloverIcon;
